window.YW_DATA = {
  "molds": [
    {
      "mold_id": "M001",
      "name": "圆珠",
      "name_en": "Round Bead",
      "category": "bead",
      "shape_type": "round",
      "nominal_size_mm": 11,
      "thread_span_mm": 11,
      "layout_span_mm": null,
      "active": true,
      "notes": "圆珠，小尺寸",
      "notes_en": "Round bead, smaller size"
    },
    {
      "mold_id": "M002",
      "name": "圆珠",
      "name_en": "Round Bead",
      "category": "bead",
      "shape_type": "round",
      "nominal_size_mm": 14,
      "thread_span_mm": 14,
      "layout_span_mm": null,
      "active": true,
      "notes": "圆珠，大尺寸；原始备注为约13-14mm，先按14mm录入",
      "notes_en": "Round bead, larger size; original note was approximately 13–14 mm, recorded as 14 mm for now"
    },
    {
      "mold_id": "M021",
      "name": "圆珠",
      "name_en": "Round Bead",
      "category": "bead",
      "shape_type": "round",
      "nominal_size_mm": 16,
      "thread_span_mm": 16,
      "layout_span_mm": null,
      "active": true,
      "notes": "圆珠，中尺寸；沿用 14mm 素材按 16mm 缩放",
      "notes_en": "Round bead, mid size; the 14 mm artwork scaled to 16 mm"
    },
    {
      "mold_id": "M003",
      "name": "方珠",
      "name_en": "Square Bead",
      "category": "bead",
      "shape_type": "square",
      "nominal_size_mm": 11,
      "thread_span_mm": 11,
      "layout_span_mm": null,
      "active": true,
      "notes": "方珠",
      "notes_en": "Square bead"
    },
    {
      "mold_id": "M004",
      "name": "花珠1",
      "name_en": "Flower Bead 1",
      "category": "bead",
      "shape_type": "flower",
      "nominal_size_mm": 11,
      "thread_span_mm": 11,
      "layout_span_mm": null,
      "active": true,
      "notes": "花珠1",
      "notes_en": "Flower bead 1"
    },
    {
      "mold_id": "M005",
      "name": "花珠2",
      "name_en": "Flower Bead 2",
      "category": "bead",
      "shape_type": "flower",
      "nominal_size_mm": 11,
      "thread_span_mm": 11,
      "layout_span_mm": null,
      "active": true,
      "notes": "花珠2",
      "notes_en": "Flower bead 2"
    },
    {
      "mold_id": "M006",
      "name": "花珠3",
      "name_en": "Flower Bead 3",
      "category": "bead",
      "shape_type": "flower",
      "nominal_size_mm": 17,
      "thread_span_mm": 17,
      "layout_span_mm": null,
      "active": true,
      "notes": "花珠3",
      "notes_en": "Flower bead 3"
    },
    {
      "mold_id": "M007",
      "name": "花珠4",
      "name_en": "Flower Bead 4",
      "category": "bead",
      "shape_type": "flower",
      "nominal_size_mm": 17,
      "thread_span_mm": 17,
      "layout_span_mm": null,
      "active": true,
      "notes": "花珠4",
      "notes_en": "Flower bead 4"
    },
    {
      "mold_id": "M008",
      "name": "花珠5",
      "name_en": "Flower Bead 5",
      "category": "bead",
      "shape_type": "flower",
      "nominal_size_mm": 17,
      "thread_span_mm": 17,
      "layout_span_mm": null,
      "active": true,
      "notes": "花珠5",
      "notes_en": "Flower bead 5"
    },
    {
      "mold_id": "M009",
      "name": "花纹圆珠",
      "name_en": "Patterned Round Bead",
      "category": "bead",
      "shape_type": "pattern_round",
      "nominal_size_mm": 11,
      "thread_span_mm": 11,
      "layout_span_mm": null,
      "active": true,
      "notes": "带纹样的圆珠",
      "notes_en": "Round bead with a carved pattern"
    },
    {
      "mold_id": "M010",
      "name": "招财猫爪",
      "name_en": "Prosperity Cat Paw",
      "category": "bead",
      "shape_type": "inscribed_plaque",
      "nominal_size_mm": 18,
      "thread_span_mm": 18,
      "layout_span_mm": null,
      "active": true,
      "notes": "招财猫爪",
      "notes_en": "Prosperity Cat Paw",
      "ui_thumbnail_rotation_deg": 90
    },
    {
      "mold_id": "M011",
      "name": "顺遂猫爪",
      "name_en": "Smooth Sailing Cat Paw",
      "category": "bead",
      "shape_type": "inscribed_plaque",
      "nominal_size_mm": 18,
      "thread_span_mm": 18,
      "layout_span_mm": null,
      "active": true,
      "notes": "顺遂猫爪",
      "notes_en": "Smooth Sailing Cat Paw",
      "ui_thumbnail_rotation_deg": 90
    },
    {
      "mold_id": "M012",
      "name": "暴富猫爪",
      "name_en": "Sudden Wealth Cat Paw",
      "category": "bead",
      "shape_type": "inscribed_plaque",
      "nominal_size_mm": 18,
      "thread_span_mm": 18,
      "layout_span_mm": null,
      "active": true,
      "notes": "暴富猫爪",
      "notes_en": "Sudden Wealth Cat Paw",
      "ui_thumbnail_rotation_deg": 90
    },
    {
      "mold_id": "M013",
      "name": "喜乐猫爪",
      "name_en": "Joy Cat Paw",
      "category": "bead",
      "shape_type": "inscribed_plaque",
      "nominal_size_mm": 18,
      "thread_span_mm": 18,
      "layout_span_mm": null,
      "active": true,
      "notes": "喜乐猫爪",
      "notes_en": "Joy Cat Paw",
      "ui_thumbnail_rotation_deg": 90
    },
    {
      "mold_id": "M014",
      "name": "祥云菱形牌",
      "name_en": "Auspicious Cloud Plaque",
      "category": "bead",
      "shape_type": "diamond_plaque",
      "nominal_size_mm": 13,
      "thread_span_mm": 13,
      "layout_span_mm": null,
      "active": true,
      "notes": "祥云菱形牌",
      "notes_en": "Auspicious Cloud Plaque"
    },
    {
      "mold_id": "M015",
      "name": "醒狮",
      "name_en": "Lion Dance Bead",
      "category": "bead",
      "shape_type": "figurative",
      "nominal_size_mm": 12,
      "thread_span_mm": 12,
      "layout_span_mm": null,
      "active": true,
      "notes": "醒狮异形珠",
      "notes_en": "Lion dance-shaped bead",
      "ui_thumbnail_rotation_deg": 90
    },
    {
      "mold_id": "M019",
      "name": "如意",
      "name_en": "Ruyi Scepter",
      "category": "bead",
      "shape_type": "figurative",
      "nominal_size_mm": 16,
      "thread_span_mm": 16,
      "layout_span_mm": null,
      "active": true,
      "notes": "如意异形珠",
      "notes_en": "Ruyi scepter-shaped bead",
      "ui_thumbnail_rotation_deg": 90
    },
    {
      "mold_id": "M020",
      "name": "金蝉",
      "name_en": "Golden Cicada",
      "category": "bead",
      "shape_type": "figurative",
      "nominal_size_mm": 12,
      "thread_span_mm": 12,
      "layout_span_mm": null,
      "active": true,
      "notes": "金蝉异形珠",
      "notes_en": "Golden cicada-shaped bead",
      "normalize_formulas": true
    },
    {
      "mold_id": "M016",
      "name": "祥云珠",
      "name_en": "Auspicious Cloud Bead",
      "category": "bead",
      "shape_type": "figurative",
      "nominal_size_mm": 18,
      "thread_span_mm": 18,
      "layout_span_mm": null,
      "active": true,
      "notes": "祥云异形珠",
      "notes_en": "Auspicious cloud-shaped bead"
    },
    {
      "mold_id": "M022",
      "name": "梵文珠",
      "name_en": "Sanskrit Bead",
      "category": "bead",
      "shape_type": "barrel",
      "nominal_size_mm": 18,
      "thread_span_mm": 18,
      "layout_span_mm": null,
      "active": true,
      "notes": "梵文异形珠",
      "notes_en": "Sanskrit-inscribed bead",
      "normalize_formulas": true
    },
    {
      "mold_id": "M018",
      "name": "福袋",
      "name_en": "Fortune Pouch",
      "category": "bead",
      "shape_type": "figurative",
      "nominal_size_mm": 16,
      "thread_span_mm": 16,
      "layout_span_mm": null,
      "active": true,
      "notes": "福袋异形珠",
      "notes_en": "Fortune pouch-shaped bead",
      "ui_thumbnail_rotation_deg": 90
    },
    {
      "mold_id": "M023",
      "name": "娃娃",
      "name_en": "Baby Figure",
      "category": "bead",
      "shape_type": "figurative",
      "nominal_size_mm": 21,
      "thread_span_mm": 21,
      "layout_span_mm": null,
      "active": true,
      "notes": "娃娃异形珠",
      "notes_en": "Baby figure-shaped bead",
      "ui_thumbnail_rotation_deg": 90,
      "normalize_formulas": true
    },
    {
      "mold_id": "M017",
      "name": "天珠",
      "name_en": "Dzi Bead",
      "category": "bead",
      "shape_type": "barrel",
      "nominal_size_mm": 35,
      "thread_span_mm": 35,
      "layout_span_mm": null,
      "active": true,
      "notes": "天珠",
      "notes_en": "Dzi bead"
    }
  ],
  "formulas": [
    {
      "formula_id": "F01",
      "name": "薄荷绿茶",
      "name_en": "Mint Green Tea",
      "active": true,
      "description": "清凉草本先打开气味，随后是干净的绿茶感与一点微涩回甘。整体轻、透、清爽，像刚冲开的绿茶里落进一片薄荷叶。",
      "description_en": "Cool herbal notes open the scent, followed by clean green tea and a lightly astringent, lingering sweetness. Light, airy, and refreshing—like a fresh cup of green tea with a mint leaf dropped in."
    },
    {
      "formula_id": "F02",
      "name": "玫瑰红茶",
      "name_en": "Rose Black Tea",
      "active": true,
      "description": "玫瑰的柔甜花香在前，红茶带来温暖、微涩和一点熟甜感。花香不飘，茶感把甜意稳稳托住，整体柔和、圆润。",
      "description_en": "Soft, sweet rose comes first, while black tea brings warmth, a gentle astringency, and a touch of mellow sweetness. The tea keeps the floral note grounded, making the whole scent soft and rounded."
    },
    {
      "formula_id": "F03",
      "name": "清远云岚",
      "name_en": "Qingyuan Cloud Mist",
      "active": true,
      "description": "浓郁的秋山木气为骨架，带着干燥草本、轻微药感与泥土气息，后段浮出梅子般的酸甜和一点回甘。整体干爽、疏朗，气味向外展开。",
      "description_en": "Rich autumn woods form the backbone, layered with dry herbs, a faint medicinal nuance, and earthy notes. Later, a plum-like tart sweetness and gentle lingering sweetness emerge. Dry, open, and spacious, the scent unfolds outward."
    },
    {
      "formula_id": "F04",
      "name": "避瘟丹",
      "name_en": "Biwen Dan",
      "active": true,
      "description": "降真香的暖木与奶甜为底，叠着干燥草本、甘苦药香和一点清凉感。整体温暖但不闷，草木感清楚，尾段留下一点甜润。",
      "description_en": "Warm woods and a creamy sweetness from rosewood form the base, layered with dry herbs, bittersweet botanical notes, and a touch of coolness. Warm without feeling heavy, with a clear herbal character and a softly sweet finish."
    },
    {
      "formula_id": "F05",
      "name": "禅月",
      "name_en": "Zen Moon",
      "active": false,
      "description": "以乳香为核心，先是清亮的树脂气息，带一点松脂、微甜和明亮感，随后慢慢落到温润木质。整体安静、圆润，乳香饱满但不厚重。",
      "description_en": "Frankincense is at the heart of the scent: bright resin, a hint of pine, gentle sweetness, and a clear luminous quality, gradually settling into warm woods. Quiet and rounded, with a full frankincense presence that never feels heavy."
    },
    {
      "formula_id": "F999",
      "name": "定制香方",
      "name_en": "Custom Formula",
      "custom": true,
      "active": true,
      "description": "没有找到合适的现成香方？把你想要的方向和想法告诉我们，制香师会为你单独调配一款专属香方，并在一周内邮件回复建议与价格。",
      "description_en": "Didn't find the right preset blend? Tell us the direction and thoughts you have in mind, and our perfumer will compose a formula just for you — we'll reply by email within a week with our suggestion and price."
    }
  ],
  "components": [
    {
      "component_id": "M001-F01",
      "component_type": "aromatic_bead",
      "mold_id": "M001",
      "formula_id": "F01",
      "asset": "assets/beads/M001/F01.png",
      "active": true
    },
    {
      "component_id": "M002-F01",
      "component_type": "aromatic_bead",
      "mold_id": "M002",
      "formula_id": "F01",
      "asset": "assets/beads/M002/F01.png",
      "active": true
    },
    {
      "component_id": "M003-F01",
      "component_type": "aromatic_bead",
      "mold_id": "M003",
      "formula_id": "F01",
      "asset": "assets/beads/M003/F01.png",
      "active": true
    },
    {
      "component_id": "M004-F01",
      "component_type": "aromatic_bead",
      "mold_id": "M004",
      "formula_id": "F01",
      "asset": "assets/beads/M004/F01.png",
      "active": true
    },
    {
      "component_id": "M005-F01",
      "component_type": "aromatic_bead",
      "mold_id": "M005",
      "formula_id": "F01",
      "asset": "assets/beads/M005/F01.png",
      "active": true
    },
    {
      "component_id": "M006-F01",
      "component_type": "aromatic_bead",
      "mold_id": "M006",
      "formula_id": "F01",
      "asset": "assets/beads/M006/F01.png",
      "active": true
    },
    {
      "component_id": "M007-F01",
      "component_type": "aromatic_bead",
      "mold_id": "M007",
      "formula_id": "F01",
      "asset": "assets/beads/M007/F01.png",
      "active": true
    },
    {
      "component_id": "M008-F01",
      "component_type": "aromatic_bead",
      "mold_id": "M008",
      "formula_id": "F01",
      "asset": "assets/beads/M008/F01.png",
      "active": true
    },
    {
      "component_id": "M009-F01",
      "component_type": "aromatic_bead",
      "mold_id": "M009",
      "formula_id": "F01",
      "asset": "assets/beads/M009/F01.png",
      "active": true
    },
    {
      "component_id": "M010-F01",
      "component_type": "aromatic_bead",
      "mold_id": "M010",
      "formula_id": "F01",
      "asset": "assets/beads/M010/F01.png",
      "active": true
    },
    {
      "component_id": "M011-F01",
      "component_type": "aromatic_bead",
      "mold_id": "M011",
      "formula_id": "F01",
      "asset": "assets/beads/M011/F01.png",
      "active": true
    },
    {
      "component_id": "M012-F01",
      "component_type": "aromatic_bead",
      "mold_id": "M012",
      "formula_id": "F01",
      "asset": "assets/beads/M012/F01.png",
      "active": true
    },
    {
      "component_id": "M013-F01",
      "component_type": "aromatic_bead",
      "mold_id": "M013",
      "formula_id": "F01",
      "asset": "assets/beads/M013/F01.png",
      "active": true
    },
    {
      "component_id": "M014-F01",
      "component_type": "aromatic_bead",
      "mold_id": "M014",
      "formula_id": "F01",
      "asset": "assets/beads/M014/F01.png",
      "active": true
    },
    {
      "component_id": "M015-F01",
      "component_type": "aromatic_bead",
      "mold_id": "M015",
      "formula_id": "F01",
      "asset": "assets/beads/M015/F01.png",
      "active": true
    },
    {
      "component_id": "M016-F01",
      "component_type": "aromatic_bead",
      "mold_id": "M016",
      "formula_id": "F01",
      "asset": "assets/beads/M016/F01.png",
      "active": true
    },
    {
      "component_id": "M017-F01",
      "component_type": "aromatic_bead",
      "mold_id": "M017",
      "formula_id": "F01",
      "asset": "assets/beads/M017/F01.png",
      "active": true
    },
    {
      "component_id": "M001-F02",
      "component_type": "aromatic_bead",
      "mold_id": "M001",
      "formula_id": "F02",
      "asset": "assets/beads/M001/F02.png",
      "active": true
    },
    {
      "component_id": "M002-F02",
      "component_type": "aromatic_bead",
      "mold_id": "M002",
      "formula_id": "F02",
      "asset": "assets/beads/M002/F02.png",
      "active": true
    },
    {
      "component_id": "M003-F02",
      "component_type": "aromatic_bead",
      "mold_id": "M003",
      "formula_id": "F02",
      "asset": "assets/beads/M003/F02.png",
      "active": true
    },
    {
      "component_id": "M004-F02",
      "component_type": "aromatic_bead",
      "mold_id": "M004",
      "formula_id": "F02",
      "asset": "assets/beads/M004/F02.png",
      "active": true
    },
    {
      "component_id": "M005-F02",
      "component_type": "aromatic_bead",
      "mold_id": "M005",
      "formula_id": "F02",
      "asset": "assets/beads/M005/F02.png",
      "active": true
    },
    {
      "component_id": "M006-F02",
      "component_type": "aromatic_bead",
      "mold_id": "M006",
      "formula_id": "F02",
      "asset": "assets/beads/M006/F02.png",
      "active": true
    },
    {
      "component_id": "M007-F02",
      "component_type": "aromatic_bead",
      "mold_id": "M007",
      "formula_id": "F02",
      "asset": "assets/beads/M007/F02.png",
      "active": true
    },
    {
      "component_id": "M008-F02",
      "component_type": "aromatic_bead",
      "mold_id": "M008",
      "formula_id": "F02",
      "asset": "assets/beads/M008/F02.png",
      "active": true
    },
    {
      "component_id": "M009-F02",
      "component_type": "aromatic_bead",
      "mold_id": "M009",
      "formula_id": "F02",
      "asset": "assets/beads/M009/F02.png",
      "active": true
    },
    {
      "component_id": "M010-F02",
      "component_type": "aromatic_bead",
      "mold_id": "M010",
      "formula_id": "F02",
      "asset": "assets/beads/M010/F02.png",
      "active": true
    },
    {
      "component_id": "M011-F02",
      "component_type": "aromatic_bead",
      "mold_id": "M011",
      "formula_id": "F02",
      "asset": "assets/beads/M011/F02.png",
      "active": true
    },
    {
      "component_id": "M012-F02",
      "component_type": "aromatic_bead",
      "mold_id": "M012",
      "formula_id": "F02",
      "asset": "assets/beads/M012/F02.png",
      "active": true
    },
    {
      "component_id": "M013-F02",
      "component_type": "aromatic_bead",
      "mold_id": "M013",
      "formula_id": "F02",
      "asset": "assets/beads/M013/F02.png",
      "active": true
    },
    {
      "component_id": "M014-F02",
      "component_type": "aromatic_bead",
      "mold_id": "M014",
      "formula_id": "F02",
      "asset": "assets/beads/M014/F02.png",
      "active": true
    },
    {
      "component_id": "M015-F02",
      "component_type": "aromatic_bead",
      "mold_id": "M015",
      "formula_id": "F02",
      "asset": "assets/beads/M015/F02.png",
      "active": true
    },
    {
      "component_id": "M016-F02",
      "component_type": "aromatic_bead",
      "mold_id": "M016",
      "formula_id": "F02",
      "asset": "assets/beads/M016/F02.png",
      "active": true
    },
    {
      "component_id": "M017-F02",
      "component_type": "aromatic_bead",
      "mold_id": "M017",
      "formula_id": "F02",
      "asset": "assets/beads/M017/F02.png",
      "active": true
    },
    {
      "component_id": "M001-F03",
      "component_type": "aromatic_bead",
      "mold_id": "M001",
      "formula_id": "F03",
      "asset": "assets/beads/M001/F03.png",
      "active": true
    },
    {
      "component_id": "M002-F03",
      "component_type": "aromatic_bead",
      "mold_id": "M002",
      "formula_id": "F03",
      "asset": "assets/beads/M002/F03.png",
      "active": true
    },
    {
      "component_id": "M003-F03",
      "component_type": "aromatic_bead",
      "mold_id": "M003",
      "formula_id": "F03",
      "asset": "assets/beads/M003/F03.png",
      "active": true
    },
    {
      "component_id": "M004-F03",
      "component_type": "aromatic_bead",
      "mold_id": "M004",
      "formula_id": "F03",
      "asset": "assets/beads/M004/F03.png",
      "active": true
    },
    {
      "component_id": "M005-F03",
      "component_type": "aromatic_bead",
      "mold_id": "M005",
      "formula_id": "F03",
      "asset": "assets/beads/M005/F03.png",
      "active": true
    },
    {
      "component_id": "M006-F03",
      "component_type": "aromatic_bead",
      "mold_id": "M006",
      "formula_id": "F03",
      "asset": "assets/beads/M006/F03.png",
      "active": true
    },
    {
      "component_id": "M007-F03",
      "component_type": "aromatic_bead",
      "mold_id": "M007",
      "formula_id": "F03",
      "asset": "assets/beads/M007/F03.png",
      "active": true
    },
    {
      "component_id": "M008-F03",
      "component_type": "aromatic_bead",
      "mold_id": "M008",
      "formula_id": "F03",
      "asset": "assets/beads/M008/F03.png",
      "active": true
    },
    {
      "component_id": "M009-F03",
      "component_type": "aromatic_bead",
      "mold_id": "M009",
      "formula_id": "F03",
      "asset": "assets/beads/M009/F03.png",
      "active": true
    },
    {
      "component_id": "M010-F03",
      "component_type": "aromatic_bead",
      "mold_id": "M010",
      "formula_id": "F03",
      "asset": "assets/beads/M010/F03.png",
      "active": true
    },
    {
      "component_id": "M011-F03",
      "component_type": "aromatic_bead",
      "mold_id": "M011",
      "formula_id": "F03",
      "asset": "assets/beads/M011/F03.png",
      "active": true
    },
    {
      "component_id": "M012-F03",
      "component_type": "aromatic_bead",
      "mold_id": "M012",
      "formula_id": "F03",
      "asset": "assets/beads/M012/F03.png",
      "active": true
    },
    {
      "component_id": "M013-F03",
      "component_type": "aromatic_bead",
      "mold_id": "M013",
      "formula_id": "F03",
      "asset": "assets/beads/M013/F03.png",
      "active": true
    },
    {
      "component_id": "M014-F03",
      "component_type": "aromatic_bead",
      "mold_id": "M014",
      "formula_id": "F03",
      "asset": "assets/beads/M014/F03.png",
      "active": true
    },
    {
      "component_id": "M015-F03",
      "component_type": "aromatic_bead",
      "mold_id": "M015",
      "formula_id": "F03",
      "asset": "assets/beads/M015/F03.png",
      "active": true
    },
    {
      "component_id": "M016-F03",
      "component_type": "aromatic_bead",
      "mold_id": "M016",
      "formula_id": "F03",
      "asset": "assets/beads/M016/F03.png",
      "active": true
    },
    {
      "component_id": "M017-F03",
      "component_type": "aromatic_bead",
      "mold_id": "M017",
      "formula_id": "F03",
      "asset": "assets/beads/M017/F03.png",
      "active": true
    },
    {
      "component_id": "M001-F04",
      "component_type": "aromatic_bead",
      "mold_id": "M001",
      "formula_id": "F04",
      "asset": "assets/beads/M001/F04.png",
      "active": true
    },
    {
      "component_id": "M002-F04",
      "component_type": "aromatic_bead",
      "mold_id": "M002",
      "formula_id": "F04",
      "asset": "assets/beads/M002/F04.png",
      "active": true
    },
    {
      "component_id": "M003-F04",
      "component_type": "aromatic_bead",
      "mold_id": "M003",
      "formula_id": "F04",
      "asset": "assets/beads/M003/F04.png",
      "active": true
    },
    {
      "component_id": "M004-F04",
      "component_type": "aromatic_bead",
      "mold_id": "M004",
      "formula_id": "F04",
      "asset": "assets/beads/M004/F04.png",
      "active": true
    },
    {
      "component_id": "M005-F04",
      "component_type": "aromatic_bead",
      "mold_id": "M005",
      "formula_id": "F04",
      "asset": "assets/beads/M005/F04.png",
      "active": true
    },
    {
      "component_id": "M006-F04",
      "component_type": "aromatic_bead",
      "mold_id": "M006",
      "formula_id": "F04",
      "asset": "assets/beads/M006/F04.png",
      "active": true
    },
    {
      "component_id": "M007-F04",
      "component_type": "aromatic_bead",
      "mold_id": "M007",
      "formula_id": "F04",
      "asset": "assets/beads/M007/F04.png",
      "active": true
    },
    {
      "component_id": "M008-F04",
      "component_type": "aromatic_bead",
      "mold_id": "M008",
      "formula_id": "F04",
      "asset": "assets/beads/M008/F04.png",
      "active": true
    },
    {
      "component_id": "M009-F04",
      "component_type": "aromatic_bead",
      "mold_id": "M009",
      "formula_id": "F04",
      "asset": "assets/beads/M009/F04.png",
      "active": true
    },
    {
      "component_id": "M010-F04",
      "component_type": "aromatic_bead",
      "mold_id": "M010",
      "formula_id": "F04",
      "asset": "assets/beads/M010/F04.png",
      "active": true
    },
    {
      "component_id": "M011-F04",
      "component_type": "aromatic_bead",
      "mold_id": "M011",
      "formula_id": "F04",
      "asset": "assets/beads/M011/F04.png",
      "active": true
    },
    {
      "component_id": "M012-F04",
      "component_type": "aromatic_bead",
      "mold_id": "M012",
      "formula_id": "F04",
      "asset": "assets/beads/M012/F04.png",
      "active": true
    },
    {
      "component_id": "M013-F04",
      "component_type": "aromatic_bead",
      "mold_id": "M013",
      "formula_id": "F04",
      "asset": "assets/beads/M013/F04.png",
      "active": true
    },
    {
      "component_id": "M014-F04",
      "component_type": "aromatic_bead",
      "mold_id": "M014",
      "formula_id": "F04",
      "asset": "assets/beads/M014/F04.png",
      "active": true
    },
    {
      "component_id": "M015-F04",
      "component_type": "aromatic_bead",
      "mold_id": "M015",
      "formula_id": "F04",
      "asset": "assets/beads/M015/F04.png",
      "active": true
    },
    {
      "component_id": "M016-F04",
      "component_type": "aromatic_bead",
      "mold_id": "M016",
      "formula_id": "F04",
      "asset": "assets/beads/M016/F04.png",
      "active": true
    },
    {
      "component_id": "M017-F04",
      "component_type": "aromatic_bead",
      "mold_id": "M017",
      "formula_id": "F04",
      "asset": "assets/beads/M017/F04.png",
      "active": true
    },
    {
      "component_id": "M001-F05",
      "component_type": "aromatic_bead",
      "mold_id": "M001",
      "formula_id": "F05",
      "asset": "assets/beads/M001/F05.png",
      "active": true
    },
    {
      "component_id": "M002-F05",
      "component_type": "aromatic_bead",
      "mold_id": "M002",
      "formula_id": "F05",
      "asset": "assets/beads/M002/F05.png",
      "active": true
    },
    {
      "component_id": "M003-F05",
      "component_type": "aromatic_bead",
      "mold_id": "M003",
      "formula_id": "F05",
      "asset": "assets/beads/M003/F05.png",
      "active": true
    },
    {
      "component_id": "M004-F05",
      "component_type": "aromatic_bead",
      "mold_id": "M004",
      "formula_id": "F05",
      "asset": "assets/beads/M004/F05.png",
      "active": true
    },
    {
      "component_id": "M005-F05",
      "component_type": "aromatic_bead",
      "mold_id": "M005",
      "formula_id": "F05",
      "asset": "assets/beads/M005/F05.png",
      "active": true
    },
    {
      "component_id": "M006-F05",
      "component_type": "aromatic_bead",
      "mold_id": "M006",
      "formula_id": "F05",
      "asset": "assets/beads/M006/F05.png",
      "active": true
    },
    {
      "component_id": "M007-F05",
      "component_type": "aromatic_bead",
      "mold_id": "M007",
      "formula_id": "F05",
      "asset": "assets/beads/M007/F05.png",
      "active": true
    },
    {
      "component_id": "M008-F05",
      "component_type": "aromatic_bead",
      "mold_id": "M008",
      "formula_id": "F05",
      "asset": "assets/beads/M008/F05.png",
      "active": true
    },
    {
      "component_id": "M009-F05",
      "component_type": "aromatic_bead",
      "mold_id": "M009",
      "formula_id": "F05",
      "asset": "assets/beads/M009/F05.png",
      "active": true
    },
    {
      "component_id": "M010-F05",
      "component_type": "aromatic_bead",
      "mold_id": "M010",
      "formula_id": "F05",
      "asset": "assets/beads/M010/F05.png",
      "active": true
    },
    {
      "component_id": "M011-F05",
      "component_type": "aromatic_bead",
      "mold_id": "M011",
      "formula_id": "F05",
      "asset": "assets/beads/M011/F05.png",
      "active": true
    },
    {
      "component_id": "M012-F05",
      "component_type": "aromatic_bead",
      "mold_id": "M012",
      "formula_id": "F05",
      "asset": "assets/beads/M012/F05.png",
      "active": true
    },
    {
      "component_id": "M013-F05",
      "component_type": "aromatic_bead",
      "mold_id": "M013",
      "formula_id": "F05",
      "asset": "assets/beads/M013/F05.png",
      "active": true
    },
    {
      "component_id": "M014-F05",
      "component_type": "aromatic_bead",
      "mold_id": "M014",
      "formula_id": "F05",
      "asset": "assets/beads/M014/F05.png",
      "active": true
    },
    {
      "component_id": "M015-F05",
      "component_type": "aromatic_bead",
      "mold_id": "M015",
      "formula_id": "F05",
      "asset": "assets/beads/M015/F05.png",
      "active": true
    },
    {
      "component_id": "M016-F05",
      "component_type": "aromatic_bead",
      "mold_id": "M016",
      "formula_id": "F05",
      "asset": "assets/beads/M016/F05.png",
      "active": true
    },
    {
      "component_id": "M017-F05",
      "component_type": "aromatic_bead",
      "mold_id": "M017",
      "formula_id": "F05",
      "asset": "assets/beads/M017/F05.png",
      "active": true
    },
    {
      "component_id": "M018-F01",
      "component_type": "aromatic_bead",
      "mold_id": "M018",
      "formula_id": "F01",
      "asset": "assets/beads/M018/F01.png",
      "active": true
    },
    {
      "component_id": "M018-F02",
      "component_type": "aromatic_bead",
      "mold_id": "M018",
      "formula_id": "F02",
      "asset": "assets/beads/M018/F02.png",
      "active": true
    },
    {
      "component_id": "M018-F03",
      "component_type": "aromatic_bead",
      "mold_id": "M018",
      "formula_id": "F03",
      "asset": "assets/beads/M018/F03.png",
      "active": true
    },
    {
      "component_id": "M018-F04",
      "component_type": "aromatic_bead",
      "mold_id": "M018",
      "formula_id": "F04",
      "asset": "assets/beads/M018/F04.png",
      "active": true
    },
    {
      "component_id": "M018-F05",
      "component_type": "aromatic_bead",
      "mold_id": "M018",
      "formula_id": "F05",
      "asset": "assets/beads/M018/F05.png",
      "active": true
    },
    {
      "component_id": "M019-F01",
      "component_type": "aromatic_bead",
      "mold_id": "M019",
      "formula_id": "F01",
      "asset": "assets/beads/M019/F01.png",
      "active": true
    },
    {
      "component_id": "M019-F02",
      "component_type": "aromatic_bead",
      "mold_id": "M019",
      "formula_id": "F02",
      "asset": "assets/beads/M019/F02.png",
      "active": true
    },
    {
      "component_id": "M019-F03",
      "component_type": "aromatic_bead",
      "mold_id": "M019",
      "formula_id": "F03",
      "asset": "assets/beads/M019/F03.png",
      "active": true
    },
    {
      "component_id": "M019-F04",
      "component_type": "aromatic_bead",
      "mold_id": "M019",
      "formula_id": "F04",
      "asset": "assets/beads/M019/F04.png",
      "active": true
    },
    {
      "component_id": "M019-F05",
      "component_type": "aromatic_bead",
      "mold_id": "M019",
      "formula_id": "F05",
      "asset": "assets/beads/M019/F05.png",
      "active": true
    },
    {
      "component_id": "M020-F01",
      "component_type": "aromatic_bead",
      "mold_id": "M020",
      "formula_id": "F01",
      "asset": "assets/beads/M020/F01.png",
      "active": true
    },
    {
      "component_id": "M020-F02",
      "component_type": "aromatic_bead",
      "mold_id": "M020",
      "formula_id": "F02",
      "asset": "assets/beads/M020/F02.png",
      "active": true
    },
    {
      "component_id": "M020-F03",
      "component_type": "aromatic_bead",
      "mold_id": "M020",
      "formula_id": "F03",
      "asset": "assets/beads/M020/F03.png",
      "active": true
    },
    {
      "component_id": "M020-F04",
      "component_type": "aromatic_bead",
      "mold_id": "M020",
      "formula_id": "F04",
      "asset": "assets/beads/M020/F04.png",
      "active": true
    },
    {
      "component_id": "M020-F05",
      "component_type": "aromatic_bead",
      "mold_id": "M020",
      "formula_id": "F05",
      "asset": "assets/beads/M020/F05.png",
      "active": true
    },
    {
      "component_id": "M021-F01",
      "component_type": "aromatic_bead",
      "mold_id": "M021",
      "formula_id": "F01",
      "asset": "assets/beads/M021/F01.png",
      "active": true
    },
    {
      "component_id": "M021-F02",
      "component_type": "aromatic_bead",
      "mold_id": "M021",
      "formula_id": "F02",
      "asset": "assets/beads/M021/F02.png",
      "active": true
    },
    {
      "component_id": "M021-F03",
      "component_type": "aromatic_bead",
      "mold_id": "M021",
      "formula_id": "F03",
      "asset": "assets/beads/M021/F03.png",
      "active": true
    },
    {
      "component_id": "M021-F04",
      "component_type": "aromatic_bead",
      "mold_id": "M021",
      "formula_id": "F04",
      "asset": "assets/beads/M021/F04.png",
      "active": true
    },
    {
      "component_id": "M021-F05",
      "component_type": "aromatic_bead",
      "mold_id": "M021",
      "formula_id": "F05",
      "asset": "assets/beads/M021/F05.png",
      "active": true
    },
    {
      "component_id": "M022-F01",
      "component_type": "aromatic_bead",
      "mold_id": "M022",
      "formula_id": "F01",
      "asset": "assets/beads/M022/F01.png",
      "active": true
    },
    {
      "component_id": "M022-F02",
      "component_type": "aromatic_bead",
      "mold_id": "M022",
      "formula_id": "F02",
      "asset": "assets/beads/M022/F02.png",
      "active": true
    },
    {
      "component_id": "M022-F03",
      "component_type": "aromatic_bead",
      "mold_id": "M022",
      "formula_id": "F03",
      "asset": "assets/beads/M022/F03.png",
      "active": true
    },
    {
      "component_id": "M022-F04",
      "component_type": "aromatic_bead",
      "mold_id": "M022",
      "formula_id": "F04",
      "asset": "assets/beads/M022/F04.png",
      "active": true
    },
    {
      "component_id": "M022-F05",
      "component_type": "aromatic_bead",
      "mold_id": "M022",
      "formula_id": "F05",
      "asset": "assets/beads/M022/F05.png",
      "active": true
    },
    {
      "component_id": "M023-F01",
      "component_type": "aromatic_bead",
      "mold_id": "M023",
      "formula_id": "F01",
      "asset": "assets/beads/M023/F01.png",
      "active": true
    },
    {
      "component_id": "M023-F02",
      "component_type": "aromatic_bead",
      "mold_id": "M023",
      "formula_id": "F02",
      "asset": "assets/beads/M023/F02.png",
      "active": true
    },
    {
      "component_id": "M023-F03",
      "component_type": "aromatic_bead",
      "mold_id": "M023",
      "formula_id": "F03",
      "asset": "assets/beads/M023/F03.png",
      "active": true
    },
    {
      "component_id": "M023-F04",
      "component_type": "aromatic_bead",
      "mold_id": "M023",
      "formula_id": "F04",
      "asset": "assets/beads/M023/F04.png",
      "active": true
    },
    {
      "component_id": "M023-F05",
      "component_type": "aromatic_bead",
      "mold_id": "M023",
      "formula_id": "F05",
      "asset": "assets/beads/M023/F05.png",
      "active": true
    },
    {
      "component_id": "CORD-BROWN",
      "component_type": "cord",
      "mold_id": null,
      "formula_id": null,
      "name": "咖啡色",
      "name_en": "Coffee",
      "color": "#5a4032",
      "active": true
    },
    {
      "component_id": "CORD-YELLOW",
      "component_type": "cord",
      "mold_id": null,
      "formula_id": null,
      "name": "黄色",
      "name_en": "Yellow",
      "color": "#c9a24e",
      "active": true
    },
    {
      "component_id": "CORD-WHITE",
      "component_type": "cord",
      "mold_id": null,
      "formula_id": null,
      "name": "白色",
      "name_en": "White",
      "color": "#efece4",
      "active": true
    },
    {
      "component_id": "M001-F999",
      "component_type": "aromatic_bead",
      "mold_id": "M001",
      "formula_id": "F999",
      "asset": "assets/beads/M001/F999.png",
      "active": true
    },
    {
      "component_id": "M002-F999",
      "component_type": "aromatic_bead",
      "mold_id": "M002",
      "formula_id": "F999",
      "asset": "assets/beads/M002/F999.png",
      "active": true
    },
    {
      "component_id": "M003-F999",
      "component_type": "aromatic_bead",
      "mold_id": "M003",
      "formula_id": "F999",
      "asset": "assets/beads/M003/F999.png",
      "active": true
    },
    {
      "component_id": "M004-F999",
      "component_type": "aromatic_bead",
      "mold_id": "M004",
      "formula_id": "F999",
      "asset": "assets/beads/M004/F999.png",
      "active": true
    },
    {
      "component_id": "M005-F999",
      "component_type": "aromatic_bead",
      "mold_id": "M005",
      "formula_id": "F999",
      "asset": "assets/beads/M005/F999.png",
      "active": true
    },
    {
      "component_id": "M006-F999",
      "component_type": "aromatic_bead",
      "mold_id": "M006",
      "formula_id": "F999",
      "asset": "assets/beads/M006/F999.png",
      "active": true
    },
    {
      "component_id": "M007-F999",
      "component_type": "aromatic_bead",
      "mold_id": "M007",
      "formula_id": "F999",
      "asset": "assets/beads/M007/F999.png",
      "active": true
    },
    {
      "component_id": "M008-F999",
      "component_type": "aromatic_bead",
      "mold_id": "M008",
      "formula_id": "F999",
      "asset": "assets/beads/M008/F999.png",
      "active": true
    },
    {
      "component_id": "M009-F999",
      "component_type": "aromatic_bead",
      "mold_id": "M009",
      "formula_id": "F999",
      "asset": "assets/beads/M009/F999.png",
      "active": true
    },
    {
      "component_id": "M010-F999",
      "component_type": "aromatic_bead",
      "mold_id": "M010",
      "formula_id": "F999",
      "asset": "assets/beads/M010/F999.png",
      "active": true
    },
    {
      "component_id": "M011-F999",
      "component_type": "aromatic_bead",
      "mold_id": "M011",
      "formula_id": "F999",
      "asset": "assets/beads/M011/F999.png",
      "active": true
    },
    {
      "component_id": "M012-F999",
      "component_type": "aromatic_bead",
      "mold_id": "M012",
      "formula_id": "F999",
      "asset": "assets/beads/M012/F999.png",
      "active": true
    },
    {
      "component_id": "M013-F999",
      "component_type": "aromatic_bead",
      "mold_id": "M013",
      "formula_id": "F999",
      "asset": "assets/beads/M013/F999.png",
      "active": true
    },
    {
      "component_id": "M014-F999",
      "component_type": "aromatic_bead",
      "mold_id": "M014",
      "formula_id": "F999",
      "asset": "assets/beads/M014/F999.png",
      "active": true
    },
    {
      "component_id": "M015-F999",
      "component_type": "aromatic_bead",
      "mold_id": "M015",
      "formula_id": "F999",
      "asset": "assets/beads/M015/F999.png",
      "active": true
    },
    {
      "component_id": "M016-F999",
      "component_type": "aromatic_bead",
      "mold_id": "M016",
      "formula_id": "F999",
      "asset": "assets/beads/M016/F999.png",
      "active": true
    },
    {
      "component_id": "M017-F999",
      "component_type": "aromatic_bead",
      "mold_id": "M017",
      "formula_id": "F999",
      "asset": "assets/beads/M017/F999.png",
      "active": true
    },
    {
      "component_id": "M018-F999",
      "component_type": "aromatic_bead",
      "mold_id": "M018",
      "formula_id": "F999",
      "asset": "assets/beads/M018/F999.png",
      "active": true
    },
    {
      "component_id": "M019-F999",
      "component_type": "aromatic_bead",
      "mold_id": "M019",
      "formula_id": "F999",
      "asset": "assets/beads/M019/F999.png",
      "active": true
    },
    {
      "component_id": "M020-F999",
      "component_type": "aromatic_bead",
      "mold_id": "M020",
      "formula_id": "F999",
      "asset": "assets/beads/M020/F999.png",
      "active": true
    },
    {
      "component_id": "M021-F999",
      "component_type": "aromatic_bead",
      "mold_id": "M021",
      "formula_id": "F999",
      "asset": "assets/beads/M021/F999.png",
      "active": true
    },
    {
      "component_id": "M022-F999",
      "component_type": "aromatic_bead",
      "mold_id": "M022",
      "formula_id": "F999",
      "asset": "assets/beads/M022/F999.png",
      "active": true
    },
    {
      "component_id": "M023-F999",
      "component_type": "aromatic_bead",
      "mold_id": "M023",
      "formula_id": "F999",
      "asset": "assets/beads/M023/F999.png",
      "active": true
    }
  ],
  "plaque": {
    "mounting_bead": {
      "asset": "plaques/mounting/bead.png",
      "diameter_mm": 6,
      "rotation_deg": 0
    },
    "mounting_styles": [
      {
        "mounting_style": "top_bead",
        "name": "顶珠",
        "name_en": "Top Bead",
        "bead_mode": "artisan_matched",
        "price": 0,
        "active": true
      },
      {
        "mounting_style": "bottom_bead",
        "name": "底珠",
        "name_en": "Bottom Bead",
        "bead_mode": "artisan_matched",
        "price": 0,
        "active": true
      },
      {
        "mounting_style": "direct_cord",
        "name": "无珠直连",
        "name_en": "Direct Cord",
        "bead_mode": "none",
        "price": 0,
        "active": true
      }
    ],
    "categories": [
      {
        "category_id": "buddhist",
        "name": "佛教",
        "name_en": "Buddhist",
        "sort_order": 1,
        "active": true
      },
      {
        "category_id": "taoist",
        "name": "道教",
        "name_en": "Taoist",
        "sort_order": 2,
        "active": true
      },
      {
        "category_id": "chinese_culture",
        "name": "中国文化",
        "name_en": "Chinese Culture",
        "sort_order": 3,
        "active": true
      }
    ],
    "cords": [
      {
        "cord_id": "C002",
        "name": "男款黑色",
        "name_en": "Men's Black",
        "string_color": "#2b2b2b",
        "aspect": 1.484,
        "active": true
      },
      {
        "cord_id": "C001",
        "name": "女款黑色",
        "name_en": "Women's Black",
        "string_color": "#2b2b2b",
        "aspect": 1.602,
        "active": true
      },
      {
        "cord_id": "C003",
        "name": "通用粉白",
        "name_en": "Universal Pink & White",
        "string_color": "#7c3a34",
        "aspect": 1.522,
        "active": true
      },
      {
        "cord_id": "C004",
        "name": "通用黑白",
        "name_en": "Universal Black & White",
        "string_color": "#2b2b2b",
        "aspect": 1.529,
        "active": true
      },
      {
        "cord_id": "none",
        "name": "不要绳子",
        "name_en": "Plaque only",
        "string_color": "#2b2b2b",
        "aspect": 1.5,
        "no_cord": true,
        "active": true
      }
    ],
    "builder": {
      "frame_mm": {
        "width": 85,
        "height": 220
      },
      "builder_window_mm": 150,
      "builder_anchor_frac": 0.48,
      "full_fill": 0.94,
      "bead_cord_gap_mm": 1.6,
      "bead_plaque_overlap_mm": 0.4,
      "plaque_cord_overlap_mm": 0.5,
      "string_width_mm": 0.6,
      "string_color": "#2b2b2b",
      "logo_view_w_frac": 0.16,
      "logo_builder_y_frac": 0.19,
      "logo_full_y_frac": 0.45
    },
    "plaques": [
      {
        "plaque_id": "PB01",
        "name": "大势至菩萨",
        "name_en": "Mahasthamaprapta Bodhisattva",
        "category_id": "buddhist",
        "width_mm": 35,
        "height_mm": 55,
        "thickness_mm": 10,
        "supported_mounting_styles": [
          "top_bead"
        ],
        "default_mounting_style": "top_bead",
        "default_cord_id": "C002",
        "attachment_anchors": {
          "top": {
            "x": 0.5,
            "y": 0.0
          },
          "bottom": {
            "x": 0.5,
            "y": 1.0
          }
        },
        "active": true
      },
      {
        "plaque_id": "PB02",
        "name": "不动明王",
        "name_en": "Acala Wisdom King",
        "category_id": "buddhist",
        "width_mm": 35,
        "height_mm": 55,
        "thickness_mm": 10,
        "supported_mounting_styles": [
          "top_bead"
        ],
        "default_mounting_style": "top_bead",
        "default_cord_id": "C002",
        "attachment_anchors": {
          "top": {
            "x": 0.5,
            "y": 0.0
          },
          "bottom": {
            "x": 0.5,
            "y": 1.0
          }
        },
        "active": true
      },
      {
        "plaque_id": "PB03",
        "name": "虚空藏菩萨",
        "name_en": "Akasagarbha Bodhisattva",
        "category_id": "buddhist",
        "width_mm": 35,
        "height_mm": 55,
        "thickness_mm": 10,
        "supported_mounting_styles": [
          "top_bead"
        ],
        "default_mounting_style": "top_bead",
        "default_cord_id": "C002",
        "attachment_anchors": {
          "top": {
            "x": 0.5,
            "y": 0.0
          },
          "bottom": {
            "x": 0.5,
            "y": 1.0
          }
        },
        "active": true
      },
      {
        "plaque_id": "PB04",
        "name": "地藏王菩萨",
        "name_en": "Ksitigarbha Bodhisattva",
        "category_id": "buddhist",
        "width_mm": 35,
        "height_mm": 55,
        "thickness_mm": 10,
        "supported_mounting_styles": [
          "top_bead"
        ],
        "default_mounting_style": "top_bead",
        "default_cord_id": "C002",
        "attachment_anchors": {
          "top": {
            "x": 0.5,
            "y": 0.0
          },
          "bottom": {
            "x": 0.5,
            "y": 1.0
          }
        },
        "active": true
      },
      {
        "plaque_id": "PB05",
        "name": "普贤菩萨",
        "name_en": "Samantabhadra Bodhisattva",
        "category_id": "buddhist",
        "width_mm": 35,
        "height_mm": 55,
        "thickness_mm": 10,
        "supported_mounting_styles": [
          "top_bead"
        ],
        "default_mounting_style": "top_bead",
        "default_cord_id": "C002",
        "attachment_anchors": {
          "top": {
            "x": 0.5,
            "y": 0.0
          },
          "bottom": {
            "x": 0.5,
            "y": 1.0
          }
        },
        "active": true
      },
      {
        "plaque_id": "PB06",
        "name": "阿弥陀佛",
        "name_en": "Amitabha Buddha",
        "category_id": "buddhist",
        "width_mm": 35,
        "height_mm": 55,
        "thickness_mm": 10,
        "supported_mounting_styles": [
          "top_bead"
        ],
        "default_mounting_style": "top_bead",
        "default_cord_id": "C002",
        "attachment_anchors": {
          "top": {
            "x": 0.5,
            "y": 0.0
          },
          "bottom": {
            "x": 0.5,
            "y": 1.0
          }
        },
        "active": true
      },
      {
        "plaque_id": "PB07",
        "name": "观音菩萨",
        "name_en": "Guanyin Bodhisattva",
        "category_id": "buddhist",
        "width_mm": 35,
        "height_mm": 55,
        "thickness_mm": 10,
        "supported_mounting_styles": [
          "top_bead"
        ],
        "default_mounting_style": "top_bead",
        "default_cord_id": "C002",
        "attachment_anchors": {
          "top": {
            "x": 0.5,
            "y": 0.0
          },
          "bottom": {
            "x": 0.5,
            "y": 1.0
          }
        },
        "active": true
      },
      {
        "plaque_id": "PB08",
        "name": "文殊菩萨",
        "name_en": "Manjushri Bodhisattva",
        "category_id": "buddhist",
        "width_mm": 35,
        "height_mm": 55,
        "thickness_mm": 10,
        "supported_mounting_styles": [
          "top_bead"
        ],
        "default_mounting_style": "top_bead",
        "default_cord_id": "C002",
        "attachment_anchors": {
          "top": {
            "x": 0.5,
            "y": 0.0
          },
          "bottom": {
            "x": 0.5,
            "y": 1.0
          }
        },
        "active": true
      },
      {
        "plaque_id": "PB09",
        "name": "金刚杵",
        "name_en": "Vajra",
        "category_id": "buddhist",
        "width_mm": 21,
        "height_mm": 63,
        "thickness_mm": 13,
        "supported_mounting_styles": [
          "direct_cord"
        ],
        "default_mounting_style": "direct_cord",
        "default_cord_id": "C002",
        "attachment_anchors": {
          "top": {
            "x": 0.5,
            "y": 0.0
          },
          "bottom": {
            "x": 0.5,
            "y": 1.0
          }
        },
        "active": true
      },
      {
        "plaque_id": "PB10",
        "name": "拈花一笑",
        "name_en": "The Flower Sermon",
        "category_id": "buddhist",
        "width_mm": 30,
        "height_mm": 50,
        "thickness_mm": 10,
        "supported_mounting_styles": [
          "top_bead"
        ],
        "default_mounting_style": "top_bead",
        "default_cord_id": "C002",
        "attachment_anchors": {
          "top": {
            "x": 0.5,
            "y": 0.0
          },
          "bottom": {
            "x": 0.5,
            "y": 1.0
          }
        },
        "active": true
      },
      {
        "plaque_id": "PB11",
        "name": "六字真言",
        "name_en": "Six-Character Mantra",
        "category_id": "buddhist",
        "width_mm": 40,
        "height_mm": 40,
        "thickness_mm": 10,
        "supported_mounting_styles": [
          "top_bead"
        ],
        "default_mounting_style": "top_bead",
        "default_cord_id": "C002",
        "attachment_anchors": {
          "top": {
            "x": 0.5,
            "y": 0.0
          },
          "bottom": {
            "x": 0.5,
            "y": 1.0
          }
        },
        "active": true
      },
      {
        "plaque_id": "PT01",
        "name": "乾坤卦",
        "name_en": "Qian & Kun Trigrams",
        "category_id": "taoist",
        "width_mm": 35,
        "height_mm": 55,
        "thickness_mm": 10,
        "supported_mounting_styles": [
          "top_bead"
        ],
        "default_mounting_style": "top_bead",
        "default_cord_id": "C002",
        "attachment_anchors": {
          "top": {
            "x": 0.5,
            "y": 0.0
          },
          "bottom": {
            "x": 0.5,
            "y": 1.0
          }
        },
        "active": true
      },
      {
        "plaque_id": "PT02",
        "name": "兑艮卦",
        "name_en": "Dui & Gen Trigrams",
        "category_id": "taoist",
        "width_mm": 35,
        "height_mm": 55,
        "thickness_mm": 10,
        "supported_mounting_styles": [
          "top_bead"
        ],
        "default_mounting_style": "top_bead",
        "default_cord_id": "C002",
        "attachment_anchors": {
          "top": {
            "x": 0.5,
            "y": 0.0
          },
          "bottom": {
            "x": 0.5,
            "y": 1.0
          }
        },
        "active": true
      },
      {
        "plaque_id": "PT03",
        "name": "震巽卦",
        "name_en": "Zhen & Xun Trigrams",
        "category_id": "taoist",
        "width_mm": 35,
        "height_mm": 55,
        "thickness_mm": 10,
        "supported_mounting_styles": [
          "top_bead"
        ],
        "default_mounting_style": "top_bead",
        "default_cord_id": "C002",
        "attachment_anchors": {
          "top": {
            "x": 0.5,
            "y": 0.0
          },
          "bottom": {
            "x": 0.5,
            "y": 1.0
          }
        },
        "active": true
      },
      {
        "plaque_id": "PT04",
        "name": "离坎卦",
        "name_en": "Li & Kan Trigrams",
        "category_id": "taoist",
        "width_mm": 35,
        "height_mm": 55,
        "thickness_mm": 10,
        "supported_mounting_styles": [
          "top_bead"
        ],
        "default_mounting_style": "top_bead",
        "default_cord_id": "C002",
        "attachment_anchors": {
          "top": {
            "x": 0.5,
            "y": 0.0
          },
          "bottom": {
            "x": 0.5,
            "y": 1.0
          }
        },
        "active": true
      },
      {
        "plaque_id": "PT05",
        "name": "紫薇大帝",
        "name_en": "Ziwei Emperor",
        "category_id": "taoist",
        "width_mm": 30,
        "height_mm": 52,
        "thickness_mm": 10,
        "supported_mounting_styles": [
          "top_bead"
        ],
        "default_mounting_style": "top_bead",
        "default_cord_id": "C002",
        "attachment_anchors": {
          "top": {
            "x": 0.5,
            "y": 0.0
          },
          "bottom": {
            "x": 0.5,
            "y": 1.0
          }
        },
        "active": true
      },
      {
        "plaque_id": "PT07",
        "name": "山鬼花钱",
        "name_en": "Mountain Ghost Coin",
        "category_id": "taoist",
        "width_mm": 43,
        "height_mm": 43,
        "thickness_mm": 11,
        "supported_mounting_styles": [
          "top_bead"
        ],
        "default_mounting_style": "top_bead",
        "default_cord_id": "C002",
        "attachment_anchors": {
          "top": {
            "x": 0.5,
            "y": 0.0
          },
          "bottom": {
            "x": 0.5,
            "y": 1.0
          }
        },
        "active": true
      },
      {
        "plaque_id": "PT08",
        "name": "甲辰太岁符",
        "name_en": "Jiachen Tai Sui Talisman",
        "category_id": "taoist",
        "width_mm": 35,
        "height_mm": 55,
        "thickness_mm": 10,
        "supported_mounting_styles": [
          "top_bead"
        ],
        "default_mounting_style": "top_bead",
        "default_cord_id": "C002",
        "attachment_anchors": {
          "top": {
            "x": 0.5,
            "y": 0.0
          },
          "bottom": {
            "x": 0.5,
            "y": 1.0
          }
        },
        "active": true
      },
      {
        "plaque_id": "PT09",
        "name": "雷祖讳紫薇讳",
        "name_en": "Thunder Ancestor & Ziwei Seals",
        "category_id": "taoist",
        "width_mm": 35,
        "height_mm": 55,
        "thickness_mm": 10,
        "supported_mounting_styles": [
          "top_bead"
        ],
        "default_mounting_style": "top_bead",
        "default_cord_id": "C002",
        "attachment_anchors": {
          "top": {
            "x": 0.5,
            "y": 0.0
          },
          "bottom": {
            "x": 0.5,
            "y": 1.0
          }
        },
        "active": true
      },
      {
        "plaque_id": "PT10",
        "name": "紫薇七星剑",
        "name_en": "Ziwei Seven-Star Sword",
        "category_id": "taoist",
        "width_mm": 17,
        "height_mm": 52,
        "thickness_mm": 10,
        "supported_mounting_styles": [
          "direct_cord"
        ],
        "default_mounting_style": "direct_cord",
        "default_cord_id": "C002",
        "attachment_anchors": {
          "top": {
            "x": 0.5,
            "y": 0.0
          },
          "bottom": {
            "x": 0.5,
            "y": 1.0
          }
        },
        "active": true
      },
      {
        "plaque_id": "PC03",
        "name": "镂空花",
        "name_en": "Openwork Flower",
        "category_id": "chinese_culture",
        "width_mm": 26,
        "height_mm": 32,
        "thickness_mm": 11,
        "supported_mounting_styles": [
          "direct_cord"
        ],
        "default_mounting_style": "direct_cord",
        "default_cord_id": "C002",
        "attachment_anchors": {
          "top": {
            "x": 0.5,
            "y": 0.0
          },
          "bottom": {
            "x": 0.5,
            "y": 1.0
          }
        },
        "active": true
      },
      {
        "plaque_id": "PC05",
        "name": "鱼乐",
        "name_en": "Joy of Fish",
        "category_id": "chinese_culture",
        "width_mm": 43,
        "height_mm": 43,
        "thickness_mm": 11,
        "supported_mounting_styles": [
          "top_bead"
        ],
        "default_mounting_style": "top_bead",
        "default_cord_id": "C002",
        "attachment_anchors": {
          "top": {
            "x": 0.5,
            "y": 0.0
          },
          "bottom": {
            "x": 0.5,
            "y": 1.0
          }
        },
        "active": true
      },
      {
        "plaque_id": "PC06",
        "name": "岁岁平安",
        "name_en": "Peace Year After Year",
        "category_id": "chinese_culture",
        "width_mm": 43,
        "height_mm": 25,
        "thickness_mm": 7,
        "supported_mounting_styles": [
          "direct_cord"
        ],
        "default_mounting_style": "direct_cord",
        "default_cord_id": "C002",
        "attachment_anchors": {
          "top": {
            "x": 0.5,
            "y": 0.0
          },
          "bottom": {
            "x": 0.5,
            "y": 1.0
          }
        },
        "active": true
      },
      {
        "plaque_id": "PC07",
        "name": "古龙",
        "name_en": "Ancient Dragon",
        "category_id": "chinese_culture",
        "width_mm": 43,
        "height_mm": 43,
        "thickness_mm": 12,
        "supported_mounting_styles": [
          "top_bead"
        ],
        "default_mounting_style": "top_bead",
        "default_cord_id": "C002",
        "attachment_anchors": {
          "top": {
            "x": 0.5,
            "y": 0.0
          },
          "bottom": {
            "x": 0.5,
            "y": 1.0
          }
        },
        "active": true
      },
      {
        "plaque_id": "PC08",
        "name": "葫芦",
        "name_en": "Gourd",
        "category_id": "chinese_culture",
        "width_mm": 20,
        "height_mm": 35,
        "thickness_mm": 20,
        "supported_mounting_styles": [
          "direct_cord"
        ],
        "default_mounting_style": "direct_cord",
        "default_cord_id": "C002",
        "attachment_anchors": {
          "top": {
            "x": 0.5,
            "y": 0.0
          },
          "bottom": {
            "x": 0.5,
            "y": 1.0
          }
        },
        "active": true
      },
      {
        "plaque_id": "PC09",
        "name": "游心",
        "name_en": "Roaming Mind",
        "category_id": "chinese_culture",
        "width_mm": 32,
        "height_mm": 22,
        "thickness_mm": 8,
        "supported_mounting_styles": [
          "direct_cord"
        ],
        "default_mounting_style": "direct_cord",
        "default_cord_id": "C002",
        "attachment_anchors": {
          "top": {
            "x": 0.5,
            "y": 0.0
          },
          "bottom": {
            "x": 0.5,
            "y": 1.0
          }
        },
        "active": true
      },
      {
        "plaque_id": "PC10",
        "name": "福到",
        "name_en": "Fortune Arrives",
        "category_id": "chinese_culture",
        "width_mm": 30,
        "height_mm": 24,
        "thickness_mm": 8,
        "supported_mounting_styles": [
          "direct_cord"
        ],
        "default_mounting_style": "direct_cord",
        "default_cord_id": "C002",
        "attachment_anchors": {
          "top": {
            "x": 0.5,
            "y": 0.0
          },
          "bottom": {
            "x": 0.5,
            "y": 1.0
          }
        },
        "active": true
      },
      {
        "plaque_id": "PC11",
        "name": "九尾",
        "name_en": "Nine-Tailed Fox",
        "category_id": "chinese_culture",
        "width_mm": 34,
        "height_mm": 34,
        "thickness_mm": 11,
        "supported_mounting_styles": [
          "direct_cord"
        ],
        "default_mounting_style": "direct_cord",
        "default_cord_id": "C002",
        "attachment_anchors": {
          "top": {
            "x": 0.5,
            "y": 0.0
          },
          "bottom": {
            "x": 0.5,
            "y": 1.0
          }
        },
        "active": true
      }
    ]
  }
};
